import React, { useEffect, useState } from 'react';

// This page lives at /order-success
// Stripe redirects here after a successful payment with ?session_id=...
// The confirmation email is sent automatically via the stripeWebhook Cloud Function.

function OrderSuccess() {
  const [sessionId, setSessionId] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('session_id');
    if (id) setSessionId(id);
  }, []);

  return (
    <div style={{ textAlign: 'center', padding: '60px 20px', maxWidth: '600px', margin: '0 auto' }}>
      <h1>Thank you for your order! 🍫</h1>
      <p>Your payment was received successfully.</p>
      <p>
        A confirmation email is on its way to you. Please check your spam folder
        if you don't see it within a few minutes.
      </p>
      <p>
        Your order will be shipped to you soon.
      </p>
      {sessionId && (
        <p style={{ fontSize: '0.8rem', color: '#999', marginTop: '40px' }}>
          Order reference: {sessionId}
        </p>
      )}
      <a href="/" style={{ display: 'inline-block', marginTop: '30px', textDecoration: 'underline' }}>
        Back to home
      </a>
    </div>
  );
}

export default OrderSuccess;